export default __webpack_public_path__ + "static/media/Selçuk Eser_Founder.jpg.fafd4ee0.png";